import { FormInstance } from 'antd'
import type { ValidateErrorEntity } from 'rc-field-form/lib/interface'

export const validateIsEmail = (email: string) => {
  if (!email?.trim()?.length) return false

  return email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)
}

export const validateForms = async (
  forms: (FormInstance | undefined)[]
): Promise<void> => {
  const activeForms = forms.filter((form): form is FormInstance =>
    Boolean(form)
  )

  try {
    await Promise.all(activeForms.map((form) => form.validateFields()))
  } catch (error) {
    const errorInfo = error as ValidateErrorEntity<unknown>

    const {
      name: errorField,
      errors: [errorMessage],
    } = errorInfo.errorFields?.[0] ?? {}

    const formWithError = activeForms.find(
      (form) => form.getFieldError(errorField)[0] === errorMessage
    )

    if (formWithError) {
      formWithError.scrollToField(errorField, { block: 'center' })
    }

    throw error
  }
}
